module.exports = __webpack_public_path__ + "img/bankaccount-icon.1573e325.svg";